if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      //this.form.querySelector('[name=id]').disabled = false;
      this.variantIdInput.disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      this.submitButtonText = this.submitButton.querySelector('span');
      if (document.querySelector('cart-drawer')) {
        if(this.submitButton) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }
      }

      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    async onSubmitHandler(evt) {
      evt.preventDefault();
      const faceSaleAllowed = await this.validateFaceToFaceSale();
      if (!faceSaleAllowed) return;
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      const quantityInput = this.form.querySelector('[name="quantity"]') || document.querySelector(`input[name="quantity"][form="${this.form.id}"]`);
      if (quantityInput && window.FarmexCartSkuLimit) {
        const qty = parseInt(quantityInput.value, 10) || 0;
        const max = parseInt(quantityInput.max || quantityInput.getAttribute('data-max'), 10);
        if (!isNaN(max) && qty > max) {
          quantityInput.value = Math.max(0, max);
          window.FarmexCartSkuLimit.showLimitModal(null, max);
          return;
        }
        if (qty <= 0 || (!isNaN(max) && max <= 0)) {
          window.FarmexCartSkuLimit.showLimitModal(null, 0);
          this.handleErrorMessage(`Máximo ${window.FarmexCartSkuLimit.MAX_PER_SKU} unidades de este producto en el carrito.`);
          return;
        }
      }

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      try {
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        const formData = new FormData(this.form);
        if (quantityInput && quantityInput.dataset.productSku) {
          formData.set('sku', quantityInput.dataset.productSku);
        }
        if (this.cart) {
          formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        const response = await fetch(`${routes.cart_add_url}`, config).then((res) => res.json());
        if (response.status) {
          publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: formData.get('id'), errors: response.description, message: response.message});
          this.handleErrorMessage(response.description);

          const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
          if (!soldOutMessage) return;
          this.submitButton.setAttribute('aria-disabled', true);
          this.submitButton.querySelector('span').classList.add('hidden');
          soldOutMessage.classList.remove('hidden');
          this.error = true;
          return;
        } else if (!this.cart) {
          window.location = window.routes.cart_url;
          return;
        }

        if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', productVariantId: formData.get('id'), cartData: response});
        this.error = false;
        const quickAddModal = this.closest('quick-add-modal');
        if (quickAddModal) {
          document.body.addEventListener('modalClosed', () => {
            setTimeout(() => { this.cart.renderContents(response) });
          }, { once: true });
          quickAddModal.hide(true);
        } else {
          this.cart.renderContents(response);
        }
      } catch (e) {
        console.error(e);
      } finally {
        this.submitButton.classList.remove('loading');
        if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
        if (!this.error) this.submitButton.removeAttribute('aria-disabled');
        this.querySelector('.loading-overlay__spinner').classList.add('hidden');
      }
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }

    toggleSubmitButton(disable = true, text) {
      if (disable) {
        this.submitButton.setAttribute('disabled', 'disabled');
        if (text) this.submitButtonText.textContent = text;
      } else {
        this.submitButton.removeAttribute('disabled');
        this.submitButtonText.textContent = window.variantStrings.addToCart;
      }
    }

    get variantIdInput() {
      return this.form.querySelector('[name=id]');
    }

    getFaceSaleUrl() {
      const endpoint = (this.dataset.faceSaleEndpoint || '').trim();
      const productId = this.dataset.productId || '';
      if (!endpoint || !productId) return null;
      return `${endpoint}${productId}`;
    }

    async validateFaceToFaceSale() {
      const url = this.getFaceSaleUrl();
      if (!url) return true;

      try {
        const response = await fetch(url, { method: 'GET' });
        const payload = await response.json();
        const isFaceToFaceSale = Boolean(payload && payload.is_face_to_face_sale === true);
        if (isFaceToFaceSale) {
          this.handleErrorMessage(this.dataset.faceSaleBlockMessage || 'Este producto solo se vende de forma presencial.');
          return false;
        }
        return true;
      } catch (error) {
        console.error(error);
        this.handleErrorMessage('No fue posible validar la venta online de este producto.');
        return false;
      }
    }
  });
}
